export const supportEmail = 'support@loki-dev.com';


export const QR_CODE_URL = '/images/qr-code.jpg';
export const BACKGROUND_LIGHT = '/images/about_light.webp';
export const BACKGROUND_DARK = '/images/about_dark.webp';

export const textPrimaryLight = '#4A1A3A';
export const textPrimaryDark = '#FDEFF4';
